module.exports = __webpack_public_path__ + "img/horizontal_7_5_5010.9efe5b79.png";